// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TQWl1","image":"styles_image__Aquf8","buttonImage":"styles_buttonImage__uDDxw","uploadInput":"styles_uploadInput__NtbSf"};